import { ProductRight, ProductPermission, AuthorisedUser, TradingEntity, MarketType } from 'api'

export function canTrade(productRights: ProductRight[]): boolean {
  return productRights.some(right => right.permission === ProductPermission.WRITE || right.permission === ProductPermission.TRADE)
}

export function canTradeSector(productSectorId: string, productRights: ProductRight[], marketType?: MarketType | null): boolean {
  return productRights.some(right => {
    if (marketType) {
      return (
        right.productSectorId === productSectorId &&
        (right.permission === ProductPermission.WRITE || right.permission === ProductPermission.TRADE) &&
        right.marketType === marketType
      )
    }

    return (
      right.productSectorId === productSectorId &&
      (right.permission === ProductPermission.WRITE || right.permission === ProductPermission.TRADE)
    )
  })
}

export const userCanTradeSector = (productSectorId: string, user: AuthorisedUser, marketType?: MarketType | null) =>
  canTradeSector(productSectorId, user.productRights, marketType)

export const tradingEntityCanTradeSector = (productSectorId: string, fund: TradingEntity | null, marketType?: MarketType | null) =>
  fund ? canTradeSector(productSectorId, fund.productRights, marketType) : false
